export const PRACTICE_TEST_LATELY_5 = [2026, 2025, 2024, 2023, 2022, 2021]
export const PRACTICE_TEST_YEARS = [
  2020, 2019, 2018, 2017, 2016, 2015, 2014, 2013, 2012, 2011, 2010, 2009, 2008, 2007, 2006, 2005,
  2004,
]

export const PRACTICE_TEST_ALL_YEAR = [...PRACTICE_TEST_LATELY_5, ...PRACTICE_TEST_YEARS]

export const PRACTICE_TEST_MONTH = [3, 4, 5, 6, 7, 9, 10, 11]
